module.exports = __webpack_public_path__ + "static/img/elegantMannersBig2.735b032a.png";